import { styled, keyframes } from '@mui/material'

const stretch = keyframes`
  from {
    height: 4px;
  }
  50% {
    height: 8px;
  }
  to {
    height: 4px;
  }
`

const Container = styled('div')(({ theme }) => ({
  width: 26,
  height: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 10,

  gap: 2,
  border: '2px solid #fff',
  background: '#fff',

  '& > span': {
    width: 2,
    height: 4,
    display: 'block',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 2,
    animationName: stretch,
    animationDuration: '1.5s',
    animationIterationCount: 'infinite',
  },

  "&[data-hasStroke='true']": {
    background: 'linear-gradient(270deg, #99CAFF 0%, #1A87FF 100%)',

    '& > span': {
      backgroundColor: '#fff',
    },
  },
}))

export function ActiveAudioWaves({
  hasStroke,
  className,
}: {
  hasStroke?: boolean
  className?: string
}) {
  return (
    <Container className={className} data-hasStroke={hasStroke}>
      <span style={{ animationDelay: '800ms' }} />
      <span style={{ animationDelay: '500ms' }} />
      <span />
    </Container>
  )
}

ActiveAudioWaves.defaultProps = {
  hasStroke: false,
  className: undefined,
}
